module.exports = __webpack_public_path__ + "imgs/sativa.c73b1f48dde22ce8fcc4aa5c3fce295b.jpg";